import { useEffect, useState } from "react";
import { ArrowRight, FlaskConical, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";
import EmptyState from "@/components/EmptyState";
import { useMeta } from "@/lib/useMeta";
import { APP_URL } from "@/lib/config";

// আসল Mumtahin editor (tiptap, katex...) ভারী — শুধু এই পেজ খুললেই লোড হয়।
//
// কেন React.lazy + <Suspense> নয়: chunk ব্রাউজারের ক্যাশে থাকলে (দ্বিতীয়বার খুললে) Suspense-এর
// "লুকানো → আবার দেখানো" ধাপে React 19 এডিটর subtree-র effect আবার চালায়, আর আসল অ্যাপের
// TiptapEditor তখন আগেই destroy-হয়ে-যাওয়া Tiptap এডিটরে `commands.setContent` ডাকে →
// "Cannot read properties of null (reading 'commands')" এবং পুরো পেজ ফাঁকা (বারবার খুললে ২–৪ বারের মধ্যে ধরা পড়ত)।
// ভেন্ডর করা কোড এডিট করা যায় না, তাই লোডটা এখানে হাতে করা — Suspense ছাড়া, এডিটর একবারই mount হয়।
function LiveEditorLoader() {
  const [Editor, setEditor] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let alive = true;
    import("@/live/LiveEditor")
      .then((m) => alive && setEditor(() => m.default))
      .catch((err) => {
        console.error("Live Try failed to load:", err);
        if (alive) setFailed(true);
      });
    return () => {
      alive = false;
    };
  }, []);

  if (Editor) return <Editor />;
  if (failed) {
    return (
      <EmptyState
        title="Live Try লোড করা যায়নি"
        actions={
          <Button onClick={() => window.location.reload()}>
            <RefreshCw aria-hidden="true" />
            আবার চেষ্টা করুন
          </Button>
        }
      >
        ইন্টারনেট সংযোগ দেখে পেজটি আবার লোড করুন।
      </EmptyState>
    );
  }
  return <div className="h-[70vh] animate-pulse rounded-2xl border border-border bg-muted" aria-busy="true" />;
}

export default function Try() {
  useMeta({
    title: "Live Try — মুমতাহিন গ্যালারি",
    description: "সাইন আপ ছাড়াই মুমতাহিনের আসল এডিটরে প্রশ্নপত্র বানিয়ে দেখুন।",
  });

  return (
    <div className="container pb-8 pt-6 sm:pt-10">
      <div className="no-print mb-6">
        <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-accent px-3.5 py-1 text-sm text-accent-foreground">
          <FlaskConical className="h-4 w-4" aria-hidden="true" />
          সাইন আপ লাগবে না
        </p>
        <h1 className="font-display text-2xl font-bold text-foreground sm:text-3xl">Live Try</h1>
        <p className="mt-1.5 max-w-2xl text-muted-foreground">
          এটা মুমতাহিন অ্যাপের আসল এডিটর, ব্লক আর প্রিভিউ দুটোই হুবহু এক। এখানে পাঁচ ধরনের ব্লক দেওয়া আছে; যা লিখবেন তা সেভ হবে না,
          পেজ রিফ্রেশ করলে শুরুর অবস্থায় ফিরে যাবে।
        </p>
      </div>

      <LiveEditorLoader />

      <div className="no-print mt-8 flex flex-col items-start justify-between gap-4 rounded-2xl border border-primary/15 bg-accent/60 p-5 sm:flex-row sm:items-center sm:p-6">
        <p className="max-w-xl text-sm text-foreground">
          টেবিল, ভাসমান বক্স, লিস্ট, PDF export, টেমপ্লেটসহ পুরো ফিচার মূল অ্যাপে আছে।
        </p>
        <Button asChild size="lg" className="shrink-0">
          <a href={APP_URL} target="_blank" rel="noopener noreferrer">
            মূল অ্যাপে যান
            <ArrowRight aria-hidden="true" />
          </a>
        </Button>
      </div>
    </div>
  );
}
